import { ns } from 'solid-ui';
import { readAttribution } from './attribution';
export function read(subject, store) {
    const content = store.any(subject, ns.as('content'));
    const published = store.any(subject, ns.as('published'));
    const attributedTo = readAttribution(subject, store);
    if (!content) {
        return null;
    }
    return {
        content: content.value,
        published: published && new Date(published.value),
        attributedTo,
    };
}
//# sourceMappingURL=note.js.map